import { render, staticRenderFns } from "./ModalCharges.vue?vue&type=template&id=2c7cb790&"
import script from "./ModalCharges.vue?vue&type=script&lang=js&"
export * from "./ModalCharges.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports